export const Endpoints = {
  CONNECT_URL: process.env.NEXT_PUBLIC_CONNECT_URL,
  CMDTYMARKETPLACE_URL: process.env.NEXT_PUBLIC_CMDTYMARKETPLACE_URL,
  PROXY_WEBAPP_URL: process.env.NEXT_PUBLIC_WEBAPP_PROXY_URL
}
